export default "__VITE_ASSET__zhXbFwsU__"